import type { HelmInspectQuery } from '@features/fields/api/useHelmInspect'
import type { UseFormReturn } from 'react-hook-form'
import { CircleSpinner } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'

import { Corners } from './Corners'
import { Corridors } from './Corridors'
import type { FormValues } from './formtypes'
import { Headlands } from './Headlands'
import { Holes } from './Holes'

export const Overrides = ({
  form,
  inspectQuery,
  holeCount,
  corridorCount
}: {
  form: UseFormReturn<FormValues>
  inspectQuery: HelmInspectQuery
  holeCount: number
  corridorCount: number
}) => {
  const { t } = useLocalization()

  if (inspectQuery.isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <CircleSpinner />
      </div>
    )
  }
  if (inspectQuery.isError) {
    return (
      <p className="px-1 py-4 text-sm text-red-600">
        {inspectQuery.error.message ?? t(($) => $.messages.errorOccurredTitle)}
      </p>
    )
  }
  return (
    <div className="flex flex-col divide-y divide-gray-100">
      {inspectQuery.isFetching && (
        <div className="flex items-center gap-2 py-2 text-xs text-gray-500">
          <CircleSpinner size="size-3" />
          <span>{t(($) => $.planning.computingPreview)}</span>
        </div>
      )}
      <Headlands form={form} inspectQuery={inspectQuery} />
      <Corners form={form} inspectQuery={inspectQuery} />
      {holeCount > 0 && <Holes form={form} inspectQuery={inspectQuery} />}
      {corridorCount > 0 && <Corridors form={form} inspectQuery={inspectQuery} />}
    </div>
  )
}
